import React, { useMemo } from 'react'
import { PromptOverrideSource } from '@trustero/trustero-api-web/lib/promptoverridesources/promptoverridesources_pb'
import { SelectItem } from 'src/components/Reusable/SelectDropdown/SelectDropdown.constants'
import { FlexRow } from 'src/components/Reusable/Flex'
import { SelectDropdown } from 'src/components/Reusable/SelectDropdown'

export const PromptOverrideSourcePicker = ({
  selectedSourceId,
  onSelect,
  promptOverrideSources,
  isLoading,
}: {
  selectedSourceId: string
  onSelect: (sourceId: string) => void
  promptOverrideSources: PromptOverrideSource[]
  isLoading: boolean
}): JSX.Element => {
  const promptOverrideSourceOptions = useMemo(
    () => [
      {
        name: 'None (Use Defaults)',
        value: '',
      },

      ...((promptOverrideSources.map((source) => ({
        name: source.getName(),
        value: source.getId(),
      })) as SelectItem[]) || []),
    ],
    [promptOverrideSources],
  )

  const defaultSelectedSource = useMemo(
    () =>
      promptOverrideSourceOptions.find(
        (source) => source.value === selectedSourceId,
      ),
    [promptOverrideSourceOptions, selectedSourceId],
  )
  return (
    <FlexRow isFullWidth>
      <SelectDropdown
        label="Prompt Override Source"
        items={promptOverrideSourceOptions}
        defaultValues={
          defaultSelectedSource ? [defaultSelectedSource] : undefined
        }
        placeholder="Select a prompt override source"
        onSelectCb={(selected) => onSelect(selected[0].value as string)}
        isDisabled={isLoading}
      />
    </FlexRow>
  )
}
